import {
  ADD_ERROR_ALERT,
  REMOVE_ERROR_ALERT,
  ADD_SUCCESS_ALERT,
  REMOVE_SUCCESS_ALERT,
  ADD_MESSAGE_ALERT,
  REMOVE_MESSAGE_ALERT,
  ADD_WARNING_ALERT,
  REMOVE_WARNING_ALERT
} from "./types";

export const addErrorAlert = alert => {
  return {
    type: ADD_ERROR_ALERT,
    payload: alert
  };
};

export const removeErrorAlert = id => {
  return {
    type: REMOVE_ERROR_ALERT,
    payload: id
  };
};

export const addSuccessAlert = alert => {
  return {
    type: ADD_SUCCESS_ALERT,
    payload: alert
  };
};

export const removeSuccessAlert = id => {
  return {
    type: REMOVE_SUCCESS_ALERT,
    payload: id
  };
};

export const addMessageAlert = alert => {
  return {
    type: ADD_MESSAGE_ALERT,
    payload: alert
  };
};

export const removeMessageAlert = id => {
  return {
    type: REMOVE_MESSAGE_ALERT,
    payload: id
  };
};

export const addWarningAlert = alert => {
  return {
    type: ADD_WARNING_ALERT,
    payload: alert
  };
};

export const removeWarningAlert = id => {
  return {
    type: REMOVE_WARNING_ALERT,
    payload: id
  };
};
